'use strict';
define([
    "mw-ddux/UsageLogger",
    "config",
    "blueimp-md5"
], function (
    UsageLogger,
    Config,
    md5
) {
    let LoggingService = {
        initialize: function () {
            this.startUsageLogger();
        },

        startUsageLogger: function () {
            let startParams = {
                appComponent: "MLDO",
                eventKey: "MLDO_OPEN_WITH",
                sendDirect: true,
                endPointNumber: 1, // controls if data goes to integX, currently all events go to dev data source
                sendToDev: true,
                applicationName: "GDS",
                applicationVersion: getMldoVersion() === "" ? "100" : getMldoVersion(), // app version is a required field
            };
            if (this.isDDUXEnvProd()) {
                startParams.sendToDev = false;
            }
            UsageLogger.start(startParams);
        },

        logDDUXData: function (data) {
            if (this.isDDUXLoggingDisabled()) {
                return;
            }
            if (!UsageLogger.isRunning()) {
                this.startUsageLogger();
            }
            if (this.isDDUXEnvProd()) {
                if (data && data.path) { // Hash the path
                    data.path =  md5(data.path);
                }
            }
            UsageLogger.logCustomData(
                data,
                {
                    eventKey: "MLDO_OPEN_WITH",
                    appComponent: "MLDO"
                }
            );
        },

        isDDUXLoggingDisabled: function () {
            return (typeof Config.isDDUXLoggingDisabled === "function") && Config.isDDUXLoggingDisabled();
        },

        isDDUXEnvProd: function () {
            return (typeof Config.isDDUXEnvProd === "function") && Config.isDDUXEnvProd();
        }
    };

    return LoggingService;
});